import React, { useRef, useState, useEffect } from 'react'

const GetBuyInAfterBankrupt = ({ roomData, participant, user, toggleGetChips, socket }) => {
    const [ buyInRange, setBuyInRange ] = useState( null )
    const [ dialogContent, setDialogContent ] = useState( null )
    const [ dialog, setDialog ] = useState( null )
    const [ buyInAmount, setBuyInAmount ] = useState( null )
    const [ text, setText ] = useState( null )
    const currentUser = ()=>{ if( user && participant && participant.participant ) return user._id == participant.participant._id }



    useEffect(()=>{
        // determin range if player has no chips
        if( currentUser() && participant && parseInt( participant.buyIn ) <= 0 && !participant.action ){
            
            let max
            let min

            if( !buyInRange ) setBuyInRange({ min : roomData.gameConfig.minBuyIn, max : roomData.gameConfig.maxBuyIn })
            if( !buyInAmount ) setBuyInAmount( roomData.gameConfig.maxBuyIn )

            // if( parseInt( user.virtualMoney ) >= parseInt( roomData.gameConfig.minBuyIn ) ){

            //     if( parseInt( user.virtualMoney ) >= parseInt( roomData.gameConfig.maxBuyIn ) ){
            //         max = roomData.gameConfig.maxBuyIn
            //     }else{
            //         max = user.virtualMoney
            //     }

            //     if( parseInt( user.virtualMoney ) >= parseInt( roomData.gameConfig.minBuyIn ) ){
            //         min = roomData.gameConfig.minBuyIn
            //     }else{
            //         min = user.virtualMoney
            //     }

            //     if( !buyInRange ) setBuyInRange({ min : min, max : max })
            //     if( !buyInAmount ) setBuyInAmount( max )

            // }else{
            //     // console.log('gg')
            //     if( !buyInRange ) setBuyInRange({ min : roomData.gameConfig.minBuyIn, max : roomData.gameConfig.maxBuyIn })
            //     if( !buyInAmount ) setBuyInAmount( 0 )
            //     // if( !buyInRange ) setBuyInRange({ min : 0, max : roomData.gameConfig.maxBuyIn })
            //     // if( !buyInAmount ) setBuyInAmount( 0 )
            // }
        }

        if( currentUser() && participant && parseInt( participant.buyIn ) > 0 ){
            setBuyInRange( null )
            setBuyInAmount( null )
        }
    }, [ buyInRange, buyInAmount, user, participant, roomData, text ] )


    useEffect(()=>{
        let getBuyInDialog
        let buttonGetBuyIn



        if( buyInRange && buyInAmount >= 0 ){
            console.log('vv')
            getBuyInDialog = ()=>{     
                return(
                    <div className='getBuyInHolder'>
                    <svg className='getBuyInHolderPointer' viewBox="0 0 25 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.5 0.5L25 13.582L0.5 13.582L12.5 0.5Z" fill="#00d6f5"/>
                    </svg>
                    <div className='getBuyIn'>
                        <div className='getBuyIn_wrapper'>
                            <input className="input inputGetChips" type="number" id="volumeNumber" name="volumeNumber" onChange={( e )=>{ handleBuyInInputChange( e.target.value )}} min={ buyInRange.min } max={ buyInRange.max }  step="1"  defaultValue={ buyInRange.max }></input>
                            <button className='purple_button getGuyInButton' onClick={( )=>{ validateBuyIn()}  }>Get Chips</button>
                        </div>
                        <p>{ text }</p>
                    </div>
                </div>
                )
            } 
        }else{
            setDialogContent( null )
        }

        // if( buyInRange && buyInAmount && buyInRange.max > 0 && buyInAmount !== 0 ){
            
        //     getBuyInDialog = ()=>{     
        //         return(
        //             <div className='getBuyInHolder'>
        //             <svg className='getBuyInHolderPointer' viewBox="0 0 25 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                 <path d="M12.5 0.5L25 13.582L0.5 13.582L12.5 0.5Z" fill="#00d6f5"/>
        //             </svg>
        //             <div className='getBuyIn'>
        //                 <div className='getBuyIn_wrapper'>
        //                     <input className="input inputGetChips" type="number" id="volumeNumber" name="volumeNumber" onChange={( e )=>{ handleBuyInInputChange( e.target.value )}} min={ buyInRange.min } max={ buyInRange.max }  step="1"  defaultValue={ buyInAmount }></input>
        //                     <button className='purple_button getGuyInButton' onClick={ validateBuyIn }>Get Chips</button>
        //                 </div>
        //                 { text }
        //             </div>
        //         </div>
        //         )
        //     }    
            
        //     buttonGetBuyIn = <button className='purple_button getBuyInTableButton' onClick={ showDialog }>Get Chips</button>
        // }

        // if( buyInRange && buyInRange.max == 0 && buyInAmount == 0 ){
        //     getBuyInDialog = ()=>{     
        //         return(
        //             <div className='getBuyInHolder'>
        //                 <svg className='getBuyInHolderPointer' viewBox="0 0 25 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                     <path d="M12.5 0.5L25 13.582L0.5 13.582L12.5 0.5Z" fill="#00d6f5"/>
        //                 </svg>
        //                 <div className='getBuyIn'>
        //                     <p className='getBuyIn_getMoreChipsText'>You need to buy chips to continue</p>
        //                     <div className='getBuyIn_wrapper'>
        //                         <div className='getBuyInClose' onClick={ showButton }>
        //                             <svg className='getBuyInCloseIcon' viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        //                                 <path fillRule="evenodd" clipRule="evenodd" d="M17.4856 0L20.775 3.32429L13.8134 10.3616L21 17.6249L17.7106 20.9492L10.5244 13.6863L3.28919 21L0 17.6757L7.23521 10.362L0.294176 3.34693L3.58358 0.0226404L10.5241 7.03731L17.4856 0Z" fill="white"/>
        //                             </svg>
        //                         </div>
        //                         <button className='purple_button getGuyInButton' onClick={ toggleBuyChips }><p>Buy Chips</p></button> 
        //                     </div>
        //                 </div>
        //             </div>
        //         )
        //     }

        //     buttonGetBuyIn = <button className='purple_button getBuyInTableButton' onClick={ toggleGetChips }><p>Buy Chips</p></button>
        // }

        // if( !buyInRange && !buyInAmount ){
        //     getBuyInDialog = null
        //     buttonGetBuyIn = null
        // }
        
        if(buyInRange && buyInRange.max == 0) console.log(buyInRange.max == 0)
        if(buyInRange && buyInRange.max == 0) console.log(buyInRange && buyInAmount == 0 && buyInRange.max == 0 && buyInAmount >= 0)
        if( getBuyInDialog ) setDialogContent( getBuyInDialog )

        function showButton () { setDialogContent( buttonGetBuyIn ) }
        function showDialog () { setDialogContent( getBuyInDialog ) }
        function toggleBuyChips () {
            toggleGetChips()
            setDialogContent( buttonGetBuyIn ) 

        }
        
        function handleBuyInInputChange( value ){
            setBuyInAmount( value )
            setText( null )
        }

        function validateBuyIn ( ){
            
            if( buyInAmount < buyInRange.min ) {
                setText( 'Should be between ' + buyInRange.min + ' and ' + buyInRange.max )
                setBuyInAmount( 40 )
            }
            if ( buyInAmount > buyInRange.max ) {
                setText( 'It\'s too much. Should be between' + buyInRange.min + ' and ' + buyInRange.max )
                setBuyInAmount( 500 )
            }
            if ( buyInAmount <= buyInRange.max && buyInAmount >= buyInRange.min ) {
                setBuyInAmount( buyInAmount )
                setText( null )
                socket.socket.emit( 'getBuyIn', { buyIn : parseInt( buyInAmount ) } )
            }
        }
    }, [ buyInRange, buyInAmount, text ] )


    useEffect(()=>{
        if( dialogContent ){
            setDialog( dialogContent )
        }else{
            setDialog( false )
        }
    }, [ dialogContent, buyInRange, buyInAmount ] )
  

    return ( dialog )
  }
  
  export default GetBuyInAfterBankrupt